<template>
	<Tooltip
		strategy="absolute"
		placement="top"
		down-arrow
		bubble-class="!max-w-[15.5rem] whitespace-normal text-left z-10 group-price-tooltip"
	>
		<template #default>
			<div class="bg-price-background text-brand-globus-green-dark p-1 inline-flex items-center gap-1 rounded-sm">
				<span
					class="!leading-none whitespace-nowrap text-base flex"
					:aria-label="formatPrice(String(price))"
					v-html="formatPriceWithSuperscript(price, 'text-[.75rem] -top-[.125rem]')"
				/>

				<span class="bg-white rounded-sm inline-flex border border-price-loyalty-green leading-none text-[.75rem] sm:text-[.875rem]">
					<span v-if="sale" class="font-bold tracking-tight self-center whitespace-nowrap px-1">
						-{{ $n(sale / 100, {style: 'percent'}) }}
					</span>
					<span class="inline-flex items-center py-0.5 pl-1.5 pr-1 bg-[radial-gradient(farthest-side_circle_at_60%_50%,var(--color-price-loyalty-green)_100%,transparent)] only:bg-price-loyalty-green only:px-1">
						<NuxtIcon name="custom/heart" class="text-[.875rem]" aria-hidden="true" />
					</span>
				</span>
			</div>
		</template>
		<template #tooltip>
			Tuto cenu získáte po naskenování karty Můj Globus na pokladně.
		</template>
	</Tooltip>
</template>

<script setup lang="ts">
	import type {
		ProductCatalogDTO_Models_BonusProgramPrice as BonusSale,
		Gsoa_ProductCatalog_ProductInHouse as Sale,
	} from '~/openapi';

	interface Props {
		price: number
		sale?: Sale['discountPercentage'] | BonusSale['discount']
	}

	defineProps<Props>();
</script>
